module.exports = __webpack_public_path__ + "static/media/bed.447ec665.svg";